import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getDocumentName, getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { PennylaneAccountRow } from '../ThirdPartyCommon/PennylaneAccountRow';

import { PersonPage_OnePerson_QueryDocument } from './hooks/useFindOnePersonQuery.hook';

export const PersonPage_Pennylane_Person_Fragment = graphql(`
  fragment PersonPage_Pennylane_Person_Fragment on Person {
    _id
    pennylaneCustomerBridges {
      _id
      userAccount
      activeId
    }
  }
`);

interface Props {
  readonly person: FragmentType<typeof PersonPage_Pennylane_Person_Fragment>;
}

export const Pennylane = ({ person: pPerson }: Readonly<Props>) => {
  const person = getFragmentData(PersonPage_Pennylane_Person_Fragment, pPerson);

  const { pennylaneUserAccounts } = useReferencesContext();

  return (
    <Stack spacing={3}>
      <Typography variant="h6">Synchronisation Pennylane</Typography>
      <Stack divider={<Divider />} spacing={0}>
        {pennylaneUserAccounts.map((account) => {
          const bridge = person.pennylaneCustomerBridges?.find(
            (b) => b.userAccount === account.code,
          );

          return (
            <PennylaneAccountRow
              accountCode={account.code}
              accountLabel={account.label}
              activeId={bridge?.activeId}
              invalidateQueryKey={[
                getDocumentName(PersonPage_OnePerson_QueryDocument),
                { id: person._id },
              ]}
              isEnabled={account.isEnabled}
              key={account._id}
              thirdPartyId={person._id}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};
